import "./App.css";
import PassengerCounter from "./PassengerCounter";

function App() {
  return (
    <div className="App">
      <PassengerCounter />
    </div>
  );
}

export default App;
